export const certificationStatuses = ['ACTIVE', 'EXPIRED', 'IN_PROGRESS'];
export const commonFilters = ['certificationStatuses', 'categories', 'tools', 'teams', 'users', 'playlists', 'search'];